import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getActiveContext, getContextKind } from '@/modules/auth/services/auth.api'
import { getAuthToken } from "@/modules/auth/services/auth.storage";
import { isVendorMode } from "@/shared/utils/appMode";


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNav',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const loggedOutItems = [
  { value: "home", label: "Home", icon: "mdi-home-variant-outline", routeName: "marketplace.home" },
  { value: "about", label: "Overview", icon: "mdi-information-outline", routeName: "marketplace.about" },
  { value: "contact", label: "Contact", icon: "mdi-phone-outline", routeName: "marketplace.contact" },
  { value: "login", label: "Login", icon: "mdi-login-variant", routeName: "login.page" },
];

const customerItems = [
  { value: "home", label: "Home", icon: "mdi-home-variant-outline", routeName: "marketplace.home" },
  { value: "dashboard", label: "Dashboard", icon: "mdi-chart-line", routeName: "customer.dashboard" },
  { value: "message", label: "Message", icon: "mdi-message-outline", routeName: "customer.messages" },
  { value: "settings", label: "Settings", icon: "mdi-cog-outline", routeName: "customer.settings" },
];


const companyItems = [
  { value: "home", label: "Home", icon: "mdi-home-variant-outline", routeName: "marketplace.home" },
  { value: "dashboard", label: "Dashboard", icon: "mdi-view-dashboard-outline", routeName: "company.dashboard" },
  { value: "message", label: "Message", icon: "mdi-message-outline", routeName: "company.messages" },
  { value: "settings", label: "Settings", icon: "mdi-cog-outline", routeName: "company.settings" },
];

const vendorItems = [
  { value: "home", label: "Home", icon: "mdi-home-variant-outline", routeName: "marketplace.home" },
  { value: "dashboard", label: "Dashboard", icon: "mdi-chart-line", routeName: "vendor.dashboard" },
  { value: "messages", label: "Messages", icon: "mdi-message-outline", routeName: "vendor.messages" },
  { value: "settings", label: "Settings", icon: "mdi-cog-outline", routeName: "vendor.settings" },
];

const activeValue = ref((route.name || '').toString())
const isAuthed = ref(Boolean(getAuthToken()))
const activeRole = ref(getContextKind(getActiveContext()))

const navItems = computed(() => {
  if (!isAuthed.value) return loggedOutItems

  if (isVendorMode()) {
    return vendorItems
  }
  switch (activeRole.value) {
    case "customer":
      return customerItems
    case "company":
      return companyItems
    case "vendor":
      return vendorItems
    default:
      return customerItems
  }
})

// filter out items whose named route does not exist (prevents "No match for" errors)
const resolvedNavItems = computed(() => {
  return navItems.value.filter((item) => {
    if (!item.routeName) return true
    try {
      return router.hasRoute(item.routeName)
    } catch {
      return false
    }
  })
})

watch(
  () => route.name,
  (name) => {
    activeValue.value = (name || '').toString()
  }
)

function handleRedirect(item) {

  if (item.routeName && router.hasRoute(item.routeName)) {
    router.push({ name: item.routeName })
  }
}

function syncAuthAndContext() {
  isAuthed.value = Boolean(getAuthToken())
  activeRole.value = getContextKind(getActiveContext())
}

function onStorage(e: StorageEvent) {
  if (!e.key || ["auth_token", "auth_active_context", "auth_contexts"].includes(e.key)) {
    syncAuthAndContext()
  }
}

onMounted(() => {
  window.addEventListener("auth-changed", syncAuthAndContext)
  window.addEventListener("storage", onStorage)
  syncAuthAndContext()
})

onBeforeUnmount(() => {
  window.removeEventListener("auth-changed", syncAuthAndContext)
  window.removeEventListener("storage", onStorage)
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!

  return (_openBlock(), _createBlock(_component_v_bottom_navigation, {
    modelValue: activeValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeValue).value = $event)),
    grow: "",
    class: "bottom-nav",
    color: "primary"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedNavItems.value, (item) => {
        return (_openBlock(), _createBlock(_component_v_btn, {
          key: item.value,
          value: item.routeName || item.value,
          onClick: ($event: any) => (handleRedirect(item)),
          exact: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              icon: item.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", null, _toDisplayString(item.label), 1)
          ]),
          _: 2
        }, 1032, ["value", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})